import { createApp } from 'vue';
import App from './App.vue';
import { router } from './router';

/**
 * Enable vConsole in development only.
 */
const setupVConsole = async () => {
  // if (
  //   process.env.NODE_ENV === 'production' ||
  //   typeof window === 'undefined' ||
  //   window.__VCONSOLE__
  // ) {
  //   return;
  // }

  const { default: VConsole } = await import('vconsole');
  window.__VCONSOLE__ = new VConsole();
};

// setupVConsole();

const app = createApp(App);

app.config.compilerOptions.isCustomElement = (tag) =>
  typeof tag === 'string' && tag.startsWith('wx-open-');

app.use(router);
app.mount('#app');
